"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useDeviceScreen = require("./useDeviceScreen");
Object.keys(_useDeviceScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useDeviceScreen[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useDeviceScreen[key];
    }
  });
});
var _useWindowEvent = require("./useWindowEvent");
Object.keys(_useWindowEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useWindowEvent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useWindowEvent[key];
    }
  });
});
//# sourceMappingURL=index.js.map